/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

import $ from "jquery";
import _str from "shared/util/_str";

window.AlistPremium = {
	init() {
		this.Data = {};
		this.Dom = {
			body: $("body"),
			promo: $("#enhanced_alist_promo"),
			promoAddFeatures: $("#enhanced_alist_promo .addfeatures"),
			promoNoThanks: $("#enhanced_alist_promo .nothanks"),
			confirm: $("#alist_premium_upgrade_confirmation"),

			confirmLearnMore: $(
				"#alist_premium_upgrade_confirmation .okpay-learnmore-toggler"
			),

			confirmAccept: $("#alist_premium_upgrade_confirmation .accept"),
			confirmCancel: $("#alist_premium_upgrade_confirmation .cancel"),
		};
		return this.listen();
	},

	listen() {
		this.Dom.body.on("click tap", ".js-alistpremium-open", ev => {
			let target = $(ev.currentTarget).find("button");
			this.Data.cf = target.data("cf");
			this.Data.feature = target.data("feature");
			return this.open();
		});

		this.Dom.promoAddFeatures.on("click tap", ev => {
			Modal.close();
			Modal.open(this.Dom.confirm.attr("id"));

			return ClientStats.update(
				`desktop - alist premium upgrade - promo - accepts - from:${this.Data
					.cf}`
			);
		});

		this.Dom.promoNoThanks.on("click tap", ev => {
			return Modal.close();
		});

		this.Dom.confirmLearnMore.on("click tap", ev => {
			return window.open(
				"//www.okcupid.com/legal/subscription",
				"learnmore",
				"height=300, width=550, top=0, left=0, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0"
			);
		});

		this.Dom.confirmAccept.on("click tap", ev => {
			return this.accept();
		});

		return this.Dom.confirmCancel.on("click tap", ev => {
			return Modal.close();
		});
	},

	open() {
		if (this.Data.cf) {
			ClientStats.update(
				`desktop - alist premium upgrade - promo - opens - from:${this.Data.cf}`
			);
		}
		return Modal.open(this.Dom.promo.attr("id"));
	},

	accept() {
		if (this.Data.submitting) {
			return;
		}
		this.Data.submitting = true;

		let root = "desktop - alist premium upgrade - promo - purchases";

		// change the text
		this.Dom.confirmAccept
			.html(_str("Submitting…"))
			.removeClass("blue")
			.addClass("disabled");

		return OkC.get("/okc/upgrade-premium", { api: 1 })
			.then(res => {
				return ClientStats.update({
					statname: `${root} - from:${this.Data.cf}`,

					cb: () => {
						return (window.location.href = "/upgrade?enhanced=1");
					},
				});
			})
			.catch(e => {
				let message;
				Modal.close();

				switch (e.error != null ? e.error.message : undefined) {
					case "ERROR_NOT_ALIST":
						message = _str(
							"Sign up for A-List first! Redirecting you now."
						);
						setTimeout(() => {
							return (window.location.href = "/upgrade");
						}, 5000);
						break;

					case "ERROR_ALREADY_GODMODE":
						message = _str("You’re already A-List Premium! Cool!");
						break;

					case "ERROR_PAST_EXPIRATION":
						message = _str(
							"Your A-List account is expired, try updating again! Redirecting you now."
						);
						setTimeout(() => {
							return (window.location.href = "/upgrade");
						}, 5000);
						break;

					case "ERROR_NO_PLAN_FROM_HISTORY":
						message = _str("You need an active A-List plan to upgrade!");
						break;

					case "ERROR_NOT_ON_PLAN":
						message = _str("You need an active A-List plan to upgrade!");
						break;

					case "ERROR_NO_BILLING_HISTORY":
						message = _str("You need an active A-List plan to upgrade!");
						break;

					case "ERROR_PAYMENT_NOT_FOUND":
						message = _str(
							"Add a credit card to your account before upgrading! Redirecting you now."
						);
						setTimeout(() => {
							return (window.location.href = "/settings");
						}, 5000);
						break;

					case "ERROR_FAILED_TO_CHARGE":
						message = _str(
							"We had trouble billing you, try updating your card on file! Redirecting you now."
						);
						setTimeout(() => {
							return (window.location.href = "/settings");
						}, 5000);
						break;

					case "ERROR_PAYMENT_TYPE":
						message = _str(
							"We had trouble billing you, try updating your card on file! Redirecting you now."
						);
						setTimeout(() => {
							return (window.location.href = "/settings");
						}, 5000);
						break;

					default:
						message = _str(
							"We had trouble upgrading your account, try again later!"
						);
				}

				FeedbackBanner.open({
					message,
					type: "error",
					timeout: 5000,
				});

				return ClientStats.update([
					`${root} - failed`,
					`${root} - failed - error:${e.error != null
						? e.error.message
						: undefined}`,
				]);
			});
	},
};



// WEBPACK FOOTER //
// ./src/legacy/alistpremium.js